module.exports = __webpack_public_path__ + "static/CertyfikatJakosciISO9001-8116aaa32e1eb9b8b1087a01689b5e01.pdf";